"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.projection")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.projection", {
            url: "/projecao?scenarioId&year&source&accountPlanType",
            params: {
                scenarioId: { value: null, dynamic: true },
                year: { value: null, dynamic: true },
                source: { value: null, dynamic: true },
                accountPlanType: { value: null, dynamic: true }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-projection" */ "./projection.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.projection")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "projectionViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "projection-module"
        })
        .state("nucont.accounting.company.projection.accounting", {
            url: "/contabil",
            views: {
                "projection@nucont.accounting.company.projection": {
                    component: "projectionAccountingViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "accounting" }
            },
            bodyClass: "projection-module"
        })
        .state("nucont.accounting.company.projection.fin", {
            url: "/financeiro",
            views: {
                "projection@nucont.accounting.company.projection": {
                    component: "projectionFinancialViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "fin" }
            },
            bodyClass: "projection-module"
        })
        .state("nucont.accounting.company.projection.tax", {
            url: "/fiscal",
            views: {
                "projection@nucont.accounting.company.projection": {
                    component: "projectionTaxViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "tax" }
            },
            bodyClass: "projection-module"
        })
        .state("nucont.accounting.company.projection.personnel", {
            url: "/pessoal",
            views: {
                "projection@nucont.accounting.company.projection": {
                    component: "projectionPersonnelViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "personnel" }
            },
            bodyClass: "projection-module"
        });
}
